/* eslint-disable no-confusing-arrow */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import { h5PageCount } from '../../../../../utils';
import { getCommentCount, getTopicInfo } from '../../utils/api';
import TitleImg from '../titleImg';
import SingleTitle from '../singleTitle';
import Grounds from '../../../../../base/grounds';

const { callApp } = require('@ifeng/callapp');

// 大专题
class BigTopic extends PureComponent {
    static propTypes = {
        item: PropTypes.object,
        url: PropTypes.string,
        observer: PropTypes.object,
    };

    static defaultProps = {
        isDisplaySource: true,
        isCount: true,
        isNewsTime: false,
        isFormatTime: false,
        isClickListItem: false,
    };

    state = {
        columnData: [],
    };

    ref = React.createRef();

    async componentDidMount() {
        const {
            index,
            item: { base62Id },
            observer,
        } = this.props;

        this.ref.current.setAttribute('data-index', index);

        observer.observe(this.ref.current);

        let columnData = [];
        const countArr = {};

        try {
            const topicInfo = await getTopicInfo(base62Id);

            columnData = topicInfo.map(item => ({
                ...item,
                source: item.ESsourceAlias,
                thumbnails: {
                    image: item.thumbnails,
                },
            }));
        } catch (e) {
            console.error(e);
        }

        try {
            // 生成评论地址的数组
            const urlArr = columnData.filter(item => item.commentUrl).map(item => item.commentUrl);
            const data = urlArr.length !== 0 ? await getCommentCount(urlArr) : [];

            data.forEach(item => {
                if (item.doc_url.indexOf('ucms_') === 0) {
                    countArr[item.doc_url.slice(5)] = item.join_count;
                } else {
                    countArr[item.doc_url] = item.join_count;
                }
            });
        } catch (e) {
            console.error(e);
        }

        this.setState({
            columnData: [...columnData],
            countArr: { ...countArr },
        });
    }

    handleClick = (url, id, newstype, kind, downloads, clickCountConfig) => {
        const doc_type = newstype;
        const aid = id;
        const {
            item: {
                isVideoShare
            }
        } = this.props;
        const client = isVideoShare ? 'videoApp' : 'newsApp';

        this.feedClickCountFn(clickCountConfig);

        callApp({
            client,
            docType: doc_type,
            pid: aid,
            kind,
            download: downloads && downloads.download,
            downloadAd: downloads && downloads.downloadAd
        })
    };

    feedClickCountFn = config => {
        if (window.grounds) return Grounds.jumpInNative(this.props.item);

        if (config) {
            h5PageCount([config]);
        }
    };

    render() {
        const { columnData, countArr } = this.state;
        let { url, item, observer } = this.props;
        let { title, id, callUp, newstype, clickCount, kind, downloads, _id } = item;
        const clickCountConfig = clickCount ? clickCount : '';

        if (typeof window === 'object' && window.grounds) url = null;
        
        id = _id || id;
        return (
            <div className={styles.bigTopic} ref={this.ref}>
                <div className={styles.link}>
                    {callUp === 1 ? (
                        <a onClick={this.handleClick.bind(this, url, id, newstype, kind, downloads, clickCountConfig)}>
                            <span className={styles.topicLink} />
                            {title}
                        </a>
                    ) : (
                        <a href={url} onClick={this.feedClickCountFn.bind(this, clickCountConfig)}>
                            <span className={styles.topicLink} />
                            {title}
                        </a>
                    )}
                </div>
                {columnData.map(
                    item =>
                        item.thumbnails.image.length > 0 ? (
                            <TitleImg
                                key={item.id}
                                item={item}
                                url={item.url}
                                countMapCache={countArr}
                                observer={observer}
                            />
                        ) : (
                            <SingleTitle
                                key={item.id}
                                item={item}
                                url={item.url}
                                countMapCache={countArr}
                                observer={observer}
                            />
                        ),
                )}
                {callUp === 1 ? (
                    <a
                        className={styles.more}
                        onClick={this.handleClick.bind(this, url, id, newstype, kind, downloads, clickCountConfig)}>
                        查看专题 了解更多
                        <span />
                    </a>
                ) : (
                    <a className={styles.more} href={url} onClick={this.feedClickCountFn.bind(this, clickCountConfig)}>
                        查看专题 了解更多
                        <span />
                    </a>
                )}
            </div>
        );
    }
}

export default BigTopic;
